// removed by extract-text-webpack-plugin
module.exports = {"root":"MatrixPage__root___2kDIe","matrix":"MatrixPage__matrix___3AxAe"};